// extracted by mini-css-extract-plugin
export default {"base":"vp_U5v5H"};